import { Stack, useTheme } from "@mui/material";
import i18n from "i18next";
import { Check } from "lucide-react";
import type { FC } from "react";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { LANGUAGE_OPTIONS } from "web_myplann/Infrastructure/Translations";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { SettingsRow } from "web_myplann/Profile/Components/SettingsRow";
import { ListRow } from "web_myplann/Shared/Components/ListRow";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";
import type { Language } from "web_myplann/Utils/WebViewModel";

type Props = {
	open: boolean;
	onClose: () => void;
	onSelect: (language: Language) => void;
};

export const LanguageDrawer: FC<Props> = ({ open, onClose, onSelect }) => {
	const theme = useTheme();
	const { t } = useResource();
	const hasGoalsRight = useGoalsRightOptional();

	return (
		<MyPlannDrawer
			open={open}
			onClose={onClose}
			title={t(Resources.Settings.Language)}
		>
			{hasGoalsRight ? (
				<Stack>
					{LANGUAGE_OPTIONS.map(({ code, label }, index) => (
						<ListRow
							key={code}
							title={t(label)}
							pickerSelected={i18n.language === code}
							isLast={index === LANGUAGE_OPTIONS.length - 1}
							onClick={() => onSelect(code)}
						/>
					))}
				</Stack>
			) : (
				<Stack p={1.6}>
					{LANGUAGE_OPTIONS.map(({ code, label }) => (
						<SettingsRow
							key={code}
							label={t(label)}
							rightSlot={
								i18n.language === code && (
									<Check
										size={theme.iconSize.md}
										color={theme.palette.primary.main}
									/>
								)
							}
							isLast
							onClick={() => onSelect(code)}
						/>
					))}
				</Stack>
			)}
		</MyPlannDrawer>
	);
};
